import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onResetPassword } from 'redux/actions/auth.actions';

import LayoutContainer from 'containers/LayoutContainer';
import ForgotPasswordView from 'views/public/ForgotPasswordView';
import Loading from 'components/commons/Loading';

import { IForgotPasswordFormData } from 'views/public/ForgotPasswordView/types';

const ForgotPasswordContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const loading = useTypedSelector((state) => state.auth.loading);

  const onSubmit = (formData: IForgotPasswordFormData) => dispatch(onResetPassword(formData));

  return (
    <LayoutContainer isPublic title={i18next.t('FORGOT_PASSWORD:TITLE', 'Recuperar contraseña')}>
      <ForgotPasswordView onSubmit={onSubmit} />
      {loading && <Loading isModalMode message={i18next.t<string>('FORGOT_PASSWORD:LOADING')} />}
    </LayoutContainer>
  );
};

export default ForgotPasswordContainer;
